import React from 'react';
import { EnvironmentOutlined } from '@ant-design/icons';
import { PageHeader, Layout, Tabs } from 'antd';
import { DivisionsPage } from './divisions-page';
import { SectionsPage } from './sections-page';
import { CellsPage } from './cells-page';

export function ProductionSitesMenuPage() {
  const { Content } = Layout;

  return (
    <>
      <PageHeader
        title={
          <>
            <EnvironmentOutlined /> Üretim yerleri
          </>
        }
      />
      <Content style={{ backgroundColor: '#fff' }}>
        <Tabs defaultActiveKey="1">
          <Tabs.TabPane tab="Bölüm" key="1">
            <DivisionsPage />
          </Tabs.TabPane>
          <Tabs.TabPane tab="Kısım" key="2">
            <SectionsPage />
          </Tabs.TabPane>
          <Tabs.TabPane tab="Hücre" key="3">
            <CellsPage />
          </Tabs.TabPane>
        </Tabs>
      </Content>
    </>
  );
}
